module.exports = __webpack_public_path__ + "img/two_header.8021104e.jpg";